import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface MonoTextProps {
    children: ReactNode
    size?: 'xs' | 'sm'
    muted?: boolean
    block?: boolean
    className?: string
    title?: string
    'data-testid'?: string
}

export function MonoText({children, size = 'sm', muted, block, className, title, 'data-testid': testId}: MonoTextProps) {
    return (
        <span
            className={cn(
                'font-mono',
                size === 'xs' ? 'text-xs' : 'text-sm',
                muted && 'text-muted-foreground',
                block && 'block',
                className,
            )}
            title={title}
            data-testid={testId}
        >
            {children}
        </span>
    )
}
